import cookies from 'js-cookie';
import localforage from 'localforage';
import KeyValueMap from './KeyValueMap';
import type { IStorage } from './Storage.interface';

export default class Storage implements IStorage {
  PreferLocalStorage: Boolean;
  Driver: Array<String>;
  DataBase: String;
  Table: String;
  Keys: KeyValueMap;
  #forage;

  async clear() {
    return this.#forage.clear();
  }

  async get(key: String, isCookie: Boolean = false) {
    if (isCookie) {
      try {
        return JSON.parse(cookies.get(this.value(key)));
      } catch (ignore) {
        return undefined;
      }
    }
    return this.#forage.getItem(this.value(key));
  }

  async keys() {
    return this.#forage.keys();
  }

  value(key) {
    return this.Keys.get(key) || key;
  }

  async remove(key: String, isCookie: Boolean = false, path: String = '/') {
    if (isCookie) {
      return cookies.remove(this.value(key), { path });
    }
    return this.#forage.removeItem(this.value(key));
  }

  async set(
    key: String,
    value: any,
    isCookie: Boolean = false,
    expires: Number = 1,
    path: String = '/'
  ) {
    if (isCookie) {
      return cookies.set(this.value(key), JSON.stringify(value), { expires, path });
    }
    const res = await this.#forage.setItem(this.value(key), value);
    return !res;
  }

  /**
   * Constructor
   * @param {IStorage} data
   */
  constructor(data?: IStorage) {
    this.PreferLocalStorage = data?.PreferLocalStorage || false;
    this.Driver = this.PreferLocalStorage
      ? [localforage.LOCALSTORAGE, localforage.WEBSQL, localforage.INDEXEDDB]
      : [localforage.WEBSQL, localforage.INDEXEDDB, localforage.LOCALSTORAGE];
    this.DataBase = data?.DataBase || '';
    this.Table = data?.Table || '';
    this.Keys = new KeyValueMap(data?.Keys);

    this.#forage = localforage.createInstance({
      driver: this.Driver,
      name: this.DataBase,
      storeName: this.Table
    });
  }
}
